import apis from '@/api/incidental.finance'
import { getHeaderData } from '@/utils'
// 杂费审核
const listConfig = [
    { title: '车号', key: 'carNo' },
    { title: '时间', key: 'time' },
    { title: '项目', key: 'name' },
    { title: '金额', key: 'money' },
    { title: '报销人', key: 'bxer' },
    { 
      title: '单据', key: 'bills'},
    { title: '发起时间', key: 'initiateTime' },
    { title: '发起人', key: 'proposerName' },
    { title: '备注', key: 'remark' }
]

const searchConfig = [
    { title: '车号', value: '', key: 'carNo', type: 'input' },
    { title: '时间', value: '', key: 'time', type: 'date2' },
    { title: '报销人', value: '', key: 'bxer', type: 'input' }
]

const btnConfig = [
    { bg: '#19458C', title: '导 出', key: 'export', role: 'Export',
        header_data: getHeaderData(listConfig), defaultList: [], data: [], label: '杂费审核' },
    { bg: '#009944', title: '通 过', key: 'adopt', role: 'Submit' },
    { bg: '#EA5B24', title: '驳 回', key: 'reject', role: 'Reject' }
]

function fromConfig() {
    return [
        { title: '车牌号', value: '', key: 'carNo', type: 'input' },
        { title: '车型', value: '', key: 'carType', type: 'input' },
        { title: '挂车号', value: '', key: 'carGno', type: 'input' },
        { title: '备注', value: '', key: 'remark', type: 'input' }
    ]
}

function createReject() {
    const rejectConfig = [
        { column: '驳 回' },
        { title: '审批备注', value: '', key: 'auditRemark', type: 'textarea', span: 24 },
    ]
    return rejectConfig;
}

export default function config() {
    return {
        listConfig,
        btnConfig,
        searchConfig,
        fromConfig,
        createReject,
        apis
    }
}
